export default "__VITE_ASSET__BeHKASIM__"